import type { InjectedRouter } from 'js/lib/connectToRouter';
import redirect from 'js/lib/coursera.redirect';
import user from 'js/lib/user';

import enterpriseAdminUser from 'bundles/enterprise-admin';
import EnterpriseExperiments from 'bundles/epic/clients/Enterprise';

export const navigateToContentCuration = (thirdPartyOrganizationSlug: string) => {
  const nextLink = `/content-curation/${thirdPartyOrganizationSlug}/inputs`;
  redirect.setLocation(nextLink);
};

export const navigateToFreemiumProgramSetup = (router: InjectedRouter, thirdPartyOrganizationSlug: string) => {
  const nextLink = `/o/${thirdPartyOrganizationSlug}/admin/programs/freemium-program-setup`;
  router.push(nextLink);
};

export const navigateToGwGProgramSetup = (router: InjectedRouter, thirdPartyOrganizationSlug: string) => {
  const nextLink = `/o/${thirdPartyOrganizationSlug}/admin/programs/gwg-program-setup`;
  router.push(nextLink);
};

export const navigateToNewProgramCreation = (
  router: InjectedRouter,
  thirdPartyOrganizationSlug: string,
  contractId?: string
) => {
  let programCreationLink = `/o/${thirdPartyOrganizationSlug}/program-creation`;
  if (contractId) {
    programCreationLink += `?contractId=${contractId}`;
  }
  router.push(programCreationLink);
};

export const navigateToProgramCreation = (
  isGwG: boolean,
  isFreemium: boolean,
  enableNewProgramCreation: boolean,
  thirdPartyOrganizationSlug: string,
  router?: InjectedRouter,
  contractId?: string
) => {
  const isSelfServe = !enterpriseAdminUser.isStandardContractUser();
  const enableProgramBuilderForOrg =
    EnterpriseExperiments.get('enableProgramBuilderForOrg').includes(thirdPartyOrganizationSlug);
  const unifyProgramCreationForWes = EnterpriseExperiments.get('unifyProgramCreationForWes');

  if (isSelfServe && !unifyProgramCreationForWes) {
    return navigateToContentCuration(thirdPartyOrganizationSlug);
  } else if (isGwG && router) {
    return navigateToGwGProgramSetup(router, thirdPartyOrganizationSlug);
  } else if (isFreemium && router) {
    return navigateToFreemiumProgramSetup(router, thirdPartyOrganizationSlug);
  } else if (
    enableProgramBuilderForOrg ||
    (EnterpriseExperiments.get('enableAiProgramBuilder') && user.isCourserian())
  ) {
    router?.push(`/o/${thirdPartyOrganizationSlug}/program-builder/new-program`);
    return;
  } else if (enableNewProgramCreation && router) {
    return navigateToNewProgramCreation(router, thirdPartyOrganizationSlug, contractId);
  } else {
    return navigateToContentCuration(thirdPartyOrganizationSlug);
  }
};
